import React from 'react';
import { DeviceActionProps } from './DeviceActions';
import { ListItemIcon } from '@mui/material';
import {
  ButtonIcon,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import {
  CloudDisconnectedIcon,
  CloudOnIcon,
} from '../../../../../../theme/icons';
import useCommanderStatus from '../../../../../../redux/commander/commander-status/hooks/useCommanderStatus';
import DeviceModel from '../../../../../../redux/commander/api/DeviceModel';

const iconId = 'deviceCloudConnectivity';
export function DeviceCloudConnectivityIcon(props: DeviceActionProps) {
  const { device, groupId, variant } = props;
  const { commanderStatus, isLoading } = useCommanderStatus(device.uuid);
  const cloudConnectivityStatus = new DeviceModel().cloudConnectivityStatus(
    device?.lastPing,
    commanderStatus
  );
  const tooltipContent = cloudConnectivityStatus.cloudConnectivityTooltip;
  const icon = cloudConnectivityStatus.cloudConnectivity ? (
    <CloudOnIcon />
  ) : (
    <CloudDisconnectedIcon />
  );

  return (
    <React.Fragment>
      {variant === 'menuItem' ? (
        <MenuItemPrimary className={`icon-${iconId} group-${groupId}`}>
          <ListItemIcon sx={{ color: (theme) => theme.palette.success.main }}>
            {icon}
          </ListItemIcon>
          {tooltipContent}
        </MenuItemPrimary>
      ) : (
        <ButtonIcon
          className={`icon-${iconId} group-${groupId}`}
          tooltip={tooltipContent}
          cursor="initial"
          loading={isLoading}
          disableRipple
          disableTouchRipple
          sx={{ width: '45px', height: '45px' }}
        >
          {icon}
        </ButtonIcon>
      )}
    </React.Fragment>
  );
}

export default DeviceCloudConnectivityIcon;
